module.exports = __webpack_public_path__ + "static/media/Heart.a9aed640.svg";